const MESSAGES = {
    LAB_CHANGED: "Devido a mudança de laboratório, os campos foram resetados.",
    ORDER_IN_PROGRESS: "Pedido em andamento, aguarde o e-mail de confirmação.",
};

export default MESSAGES;
